<template>
    <div class="joinMain">
        <p class="current">当前位置：<span>安全培训报名</span></p>
        <div class="join-box">
            <div class="ruleFormCode" >
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
                   
                    <el-form-item label="培训名称">
                        <el-input v-model="ruleForm.trainTitle" :disabled="true" style=" width: 332px;height: 42px;"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="ruleForm.name" placeholder="请填写您的姓名" style=" width: 332px;height: 42px;"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码" prop="phone">
                        <el-input v-model="ruleForm.phone" placeholder="请填写电话号码"  style=" width: 332px;height: 42px;"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号" prop="id">
                        <el-input v-model="ruleForm.id" placeholder="请填写身份证号码" style=" width: 332px;height: 42px;"></el-input>
                    </el-form-item>
                    <el-form-item label="单位名称">
                        <el-input v-model="ruleForm.company" placeholder="请填写单位名称" style=" width: 332px;height: 42px;"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="1寸彩色相片">
                        <div class="list-card-img">
                            <el-upload>
                                <i class="el-icon-plus borderI" ></i>
                            </el-upload>
                        </div>
                    </el-form-item> -->
                    <el-form-item label="附件图片" prop="file_items" >
                        <div class="list-card-img">
                            <img width="150px" height="200px" v-for="item in ruleForm.file_items" :key="item.FileUrl" :src="item.FileUrl" alt="">
                            <el-upload
                                ref="upload"
                                :http-request="handleTransform"
                                action="https://qiliangong.oss-cn-shenzhen.aliyuncs.com"
                            >
                                <i class="el-icon-plus borderI" ></i>
                            </el-upload>
                            
                        </div>
                        <div>
                            <p style="color: tomato;">1寸彩色相片</p>
                        </div>
                    </el-form-item>
                 
                    <el-form-item label="备注" prop="notes">
                        <el-input type="textarea" :rows="4" v-model="ruleForm.notes" placeholder="备注" class="InputW"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" style="width: 260px;" @click="handleJoin">确认并提交( ￥{{ application.price }} )</el-button>
                    </el-form-item>
                </el-form>
            

                
            </div>
        </div>
        <el-dialog
            title="扫码支付"
            width="20%"
            :visible.sync="dialogFormEdit"
            customClass="messageDialog"
            >
            <div slot="footer" class="dialog-footer">
            <div id="canvas">

            </div>
            </div>
        </el-dialog>        
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import axios from 'axios'
export default({
    data(){
        return{
            application: '',
            ruleForm: {
                trainTitle: '',
                phone: '',
                picture: '',
                notes: '',
                name: '',
                id: '',
                file_items: [],
                company: '',
                
            },
            dialogFormEdit: false,
            
            formData:{},
            rules: {
                phone: [
                    { required: true, message: '请输入电话号码', trigger: 'blur' },
                    // { min: 11, max: 11, message: '请正确输入手机号码', trigger: 'blur' }
                    { validator: this.validatePhoneNumber, trigger: 'blur' }
                ],
                name: [
                    {  required: true, message: '请填写您的名字', trigger: 'change' }
                ],
                company: [
                    {  required: true, message: '请填写单位名称', trigger: 'change' }
                ],
                id: [
                    {  required: true, message: '请填写您的身份证号', trigger: 'change' },
                    { validator: this.validateIdCard, trigger: 'blur' }
                ],
                file_items: [
                    { required: true, message: '请选择图片', trigger: 'change' }
                ]

               
               
            },
            payType: 'native',
        }
    },
    watch: {
        
    },
    methods:{
        getListcate(data){
            this.$store.dispatch('train/trainInfo',data)
                .then(res => {
                    if(res.ok){
                        this.application = res.data

                        this.ruleForm.trainTitle = this.application.name
                    }
                })
        },
        handlePictureCardPreview(file) {
            // this.dialogImageUrl = file.url;
            // this.dialogVisible = true;
        },
        fileToBlob(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onloadend = () => {
                    const blob = new Blob([reader.result], { type: file.type });
                    resolve(blob);
                };

                reader.onerror = reject;

                reader.readAsArrayBuffer(file);
            });
        },
        getUUID(){
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
            })  
        },
        handleTransform(options){
            
            console.log("上传的文件")
            console.log(options)
            let data = {}
            this.$store.dispatch('train/policy',data)
                .then(res => {
                    if(res.ok){

                        this.fileToBlob(options.file).then(blob => {
                           
                            console.log('Blob对象:', blob);
                           
                            console.log('ossPolicyX')
                            console.log(res)
                            var info = res.data
                            var key = info.dir + this.getUUID() + options.file.name.substring(options.file.name.lastIndexOf(".")) 
                            
                            console.log('key')
                            console.log(key)
                            let formData = new FormData()

                            formData.append('key', key)
                            formData.append('OSSAccessKeyId', info.accessId)
                            formData.append('policy', info.policy)
                            formData.append('signature', info.signature)
                            formData.append('success_action_status', '200')
                            formData.append('file', options.file)
                            
                            axios({
                                url: info.host,
                                contentType: false,
                                method: 'post',
                                data: formData,
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }).then(res => {
                                const { status } = res
                                if (status === 200) {
                                    var filename = options.file.name
                                    var pictureUrl = info.host + '/' + key;//获得到的url需要将其存数据库中
                                    

                                    this.ruleForm.file_items.push({
                                        filename: filename,
                                        lanmu: 'booking',
                                        picurl: pictureUrl,
                                        FileName: filename,
                                        FileUrl: pictureUrl,

                                    })  
                                    this.$forceUpdate();
                                } 
                            })
                     
                        });
						
						
					}
                })
           
        },
       
       
        validatePhoneNumber(rule, value, callback) {
            const regex = /^1[3-9]\d{9}$/;
            if (value && !regex.test(value)) {
                callback(new Error('手机号格式不正确'));
            } else {
                callback();
            }
        },
        validateIdCard(rule, value, callback){
            if(this.IsCardID(value)){
                callback()
            } else {
                callback(new Error("请输入正确的身份证号码"))
            }
        },
        /**
         * 校验身份证
         */
        IsCardID(idcard) { //--身份证号码验证-支持新的带x身份证
            var area = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外" };
            var Y, JYM;
            var S, M;
            var idcard_array = new Array();
            idcard_array = idcard.split("");
            //判断是否未输入
            if (idcard == "" || idcard == null) {
                return false;
            }
            //地区检验
            if (area[parseInt(idcard.substr(0, 2))] == null) {
                return false;
            }
            var ereg;
            //身份号码位数及格式检验
            switch (idcard.length) {
                case 15:
                var date = new Date;
                //var year=date.getFullYear().substr(2,2);
                var y = date.getFullYear() + '';
                var year = y.substr(2, 2);
                var birYear = parseInt(idcard.substr(6, 2));
                if (year - birYear > 0) {
                    birYear = birYear + 1900;
                } else {
                    birYear = birYear + 2000;
                }

                if (birYear % 4 == 0 || (birYear % 100 == 0 && birYear % 4 == 0)) {
                    ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/;//测试出生日期的合法性
                } else {
                    ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/;//测试出生日期的合法性
                }
                if (ereg.test(idcard)) {
                    return true;
                }
                else {
                    return false;
                }
                break;
                case 18:
                //18位身份号码检测
                //出生日期的合法性检查
                //闰年月日:((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))
                //平年月日:((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))
                if (parseInt(idcard.substr(6, 4)) % 4 == 0 || (parseInt(idcard.substr(6, 4)) % 100 == 0 && parseInt(idcard.substr(6, 4)) % 4 == 0)) {
                    ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/;//闰年出生日期的合法性正则表达式
                } else {
                    ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/;//平年出生日期的合法性正则表达式
                }
                if (ereg.test(idcard)) {//测试出生日期的合法性
                    //计算校验位
                    S = (parseInt(idcard_array[0]) + parseInt(idcard_array[10])) * 7
                    + (parseInt(idcard_array[1]) + parseInt(idcard_array[11])) * 9
                    + (parseInt(idcard_array[2]) + parseInt(idcard_array[12])) * 10
                    + (parseInt(idcard_array[3]) + parseInt(idcard_array[13])) * 5
                    + (parseInt(idcard_array[4]) + parseInt(idcard_array[14])) * 8
                    + (parseInt(idcard_array[5]) + parseInt(idcard_array[15])) * 4
                    + (parseInt(idcard_array[6]) + parseInt(idcard_array[16])) * 2
                    + parseInt(idcard_array[7]) * 1
                    + parseInt(idcard_array[8]) * 6
                    + parseInt(idcard_array[9]) * 3;
                    Y = S % 11;
                    M = "F";
                    JYM = "10X98765432";
                    M = JYM.substr(Y, 1);//判断校验位
                    if (M == idcard_array[17].toUpperCase()) {
                    return true;//检测ID的校验位}
                    }
                    else {
                    return false;
                    }
                }
                else {
                    return false;
                }
                break;
                default:
                return false;
                break;
            }
        },
        // 提交表单
        handleJoin(){

            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    
                    let data = {
                        booking_type: "train",
                        file_items: JSON.stringify(this.ruleForm.file_items),
                        id_number: this.ruleForm.id,
                        phone: this.ruleForm.phone,
                        real_name: this.ruleForm.name,
                        remarks: this.ruleForm.notes,
                        xid: this.$route.query.key,
                        company: this.ruleForm.company,
                        pay_type: this.payType,
                    }

                    this.$store.dispatch('train/add',data)
                        .then(res => {
                            if(res.ok){
                                // this.$alert('下单成功', '提示',{
                                //     confirmButtonText: '确定',
                                // })
                                document.getElementById( 'canvas' ).innerHTML =  '' ;
                                this.dialogFormEdit = true

                                var qrcode = new QRCode('canvas', {
                                    text: res.data.code_url,
                                    width: 150,
                                    height: 150,
                                    colorDark : '#000000',
                                    colorLight : '#ffffff',
                                    correctLevel : QRCode.CorrectLevel.H
                                });
                            
                                let timer = setInterval(() => {
                                    this.getPaystatus(res.data.order_no,timer)
                                }, 5000)
                        
                            }else{
                                if(res.code == -1){
                                    this.$router.push({
                                        path: '/login'
                                    })
                                }
                            }
                        })
                   
                }
            })
            
        },
        getPaystatus(orderNo,timer){
            setTimeout(()=>{
                let data = {
                    order_no: orderNo
                }
                this.$store.dispatch('personal/getPaystatus',data)
                    .then(res =>{
                        if(res.data.ispay == 1){
                            clearInterval(timer)
                            this.$notify({
                                title: '提示',
                                message: '支付成功',
                                type: 'success',
                            })

                            this.$router.push({
                                path: '/myOrders',
                                query: {
                                    vsstatus:'pay'
                                }
                            })

                        }
                    })
                
                
            }, 0)
        }
    },
    mounted(){
        
    },
    
    created(){
        if(localStorage.getItem('token')){
            let data = {
                id : this.$route.query.key
            }
            this.getListcate(data)
        }else{
            this.$router.push('/login')
        }
       
    }
})
</script>

<style>
@import url(../../css/join.css);
</style>

<style scoped>
.borderI{
    text-align: center;
    cursor: pointer;
    width: 150px;
    outline: 0;
    height: 200px;
    line-height: 150px;
    border-radius: 5px;
    border: 1px dashed #999999;
    font-size: 20px;
    color: #999999;
    margin-left: 5px;
}
.ruleFormCode .el-upload-list__item{
    display: none;
}
.list-card-img{
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
}
.list-card-img img{
    margin: 5px 5px;
}
::v-deep .list-card-img .el-upload-list__item{
    display: none !important;
}
::v-deep .list-card-img .el-upload-list__item-name{
    display: none !important;
}


::v-deep .el-dialog .el-dialog__header {
    line-height: 0px !important;
}
::v-deep #canvas img{
    margin: auto !important;
}

::v-deep .el-dialog__body{
    padding: 10px 0 !important;
}

</style>